var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"calibration-list"}},[_c('Table',{attrs:{"name":"calibrations","fields":_vm.fields,"rows":_vm.calibrationRows,"sortBy":'zoneName',"user-permission":_vm.userReadPermission,"has-calibration-buttons":true},on:{"changeZoneCalibration":_vm.changeZoneCalibration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }